import React, { Fragment, useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router";
import FMenuCard from "../../components/FMenuCard/FMenuCard";
import { usePhoneFormat } from "../../hooks/usePhoneFormat";
import { getProductById } from "../../api/spend";
import { deleteShortcut } from "../../api/shortcut";
import { useFormik } from "formik";
import * as Yup from "yup";
import FInputt from "../../components/FInputt/FInputt";
import { useLogin } from "../Login/hooks/useLogin";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";
import { useShareFiado } from "../../hooks/useShareFiado";
import Fselect from "../../components/Finputs/Fselect/Fselect";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";

const AmountDropdownListScreen = () => {
  const route = useNavigate();
  const { state } = useLocation();

  const { tokenDecoded } = useContext(AuthContext);
  const [accountEditable, setAccountEditable] = useState(true);
  const [amountEditable, setAmountEdiatble] = useState(true);
  const [availableAmount, setAvailableAmount] = useState([]);
  const {
    typingPhoneNumber,
    formatNumberToNationalWithoutSpaces,
    validateLocalPhone,
    inputFormatValidation,
  } = usePhoneFormat();
  const { goToTransactionDetails } = useBillPaymentArcus();

  const validate = Yup.object({
    paymentAccountNumber: Yup.number().required("Ingresa un valor válido"),
    amount: Yup.string().required("Monto requerido"),
    // description: Yup.string()
    // .required('Ingresa una descripción'),
  });

  const deleteFromFavorites = async () => {
    if (
      window.confirm(
        "¿Seguro que quieres eliminar este servicio de tus favoritos?"
      )
    ) {
      let resp = await deleteShortcut(
        state.product.id,
        state.product.accountNumber
      );
      if (resp.data.code == "PROCESS_OK") {
        route("/MainScreen");
      }
    }
  };

  const { values, setFieldValue, handleSubmit, errors, dirty, isValid } =
    useFormik({
      initialValues: {
        paymentAccountNumber: "",
        amount: Yup.string().required("Monto requerido"),
        //description: product.displayName,
      },
      onSubmit: (values) => {
        const { paymentAccountNumber, amount, description } = values;
        if (state.product?.description) {
          var comeFromFavorites = true;
        } else {
          var comeFromFavorites = false;
        }
        goToTransactionDetails({
          productId: state.product.id,
          originCurrencyId: "484",
          destinationCurrencyId: "484",
          paymentAccountNumber,
          amount: parseInt(amount),
          description,
          comeFromFavorites,
        });
      },
      validationSchema: validate,
    });

  useEffect(() => {
    if (state == null) {
      route("/");
    } else {
      let transform = transformAvailableAmount(
        state.product?.requirements?.availableAmount
      );
      formikDropdownScreen.setFieldValue("amount", transform[0]);
      setAvailableAmount(transform);
      async function gSetAccount() {
        await setAccount();
      }
      gSetAccount();
    }
  }, []);

  const transformAvailableAmount = (availableAmount) => {
    let amounts = [];

    availableAmount = availableAmount.sort(function (a, b) {
      return a - b;
    });
    for (const amount of availableAmount) {
      let myAmount = {
        value: amount,
        text: `$${amount.toString()}`,
      };

      amounts.push(myAmount);
    }
    return amounts;
  };

  const { getLastDigits } = useShareFiado();

  const setAccount = async () => {
    if (state?.product?.categoryId == "Gift Cards") {
      setFieldValue(
        "paymentAccountNumber",
        getLastDigits(
          JSON.parse(localStorage.getItem("tokenDecoded")).phone_number
        )
      );
      setAccountEditable(false);
      if (state.product.requirements.availableAmount.length >= 1) {
        //setAmountEdiatble(false);
        //formikDropdownScreen.setFieldValue('amount', state.product.requirements.availableAmount[0]);
        formikDropdownScreen.setFieldValue(
          "paymentAccountNumber",
          getLastDigits(
            JSON.parse(localStorage.getItem("tokenDecoded")).phone_number
          )
        );
      }
    }
    //console.log(values.paymentAccountNumber);
  };

  const formikDropdownScreen = useFormik({
    initialValues: {
      paymentAccountNumber: state?.product?.product?.accountNumber
        ? state?.product?.product?.accountNumber
        : "",
      amount: "",
      description: "",
    },
    onSubmit: (values) => {
      const { paymentAccountNumber, amount, description } = values;
      if (state.product?.description) {
        var comeFromFavorites = true;
      } else {
        var comeFromFavorites = false;
      }

      let number = formatNumberToNationalWithoutSpaces(
        JSON.parse(localStorage.getItem("tokenDecoded")).phone_number
      );
      console.log(number);
      let amountQty = parseFloat(amount.value);
      let productId = state?.product?.id
        ? state?.product?.id
        : state.product?.product?.id;
      goToTransactionDetails({
        productId: productId,
        originCurrencyId: "484",
        destinationCurrencyId: "484",
        paymentAccountNumber: number,
        amount: amountQty,
        description,
        comeFromFavorites,
      });
    },
    validate: (values) => {
      const errors = {};
      return errors;
    },
  });

  return (
    <>
      {state != null ? (
        <>
          <div className="w-full border-0 grid place-items-center">
            <form
              onSubmit={formikDropdownScreen.handleSubmit}
              className="w-full xs:w-[400px] sm:w-[500px]"
            >
              <div className="py-4 border-0 border-dashed p-3 mb-16 grid place-items-center">
                <img
                  src={state.product.iconUrl}
                  className="w-32 xs:w-40 sm:w-48"
                />
                {state.product?.product?.description ? (
                  <div className="text-left border-0 w-full">
                    <div className="font-bold text-[5vw] xxs:text-[22px] text-Secondary">
                      {state.product?.product?.description}
                    </div>
                    <div className="font-bold text-lg">
                      <FiconPhoneNumber
                        sizeIcon="24px"
                        phoneNumber={state.product?.product?.accountNumber}
                      />
                    </div>
                  </div>
                ) : (
                  <FInputText
                    value={formatNumberToNationalWithoutSpaces(
                      JSON.parse(localStorage.getItem("tokenDecoded"))
                        .phone_number
                    )}
                    disabled={true}
                    onChange={(e) => {
                      console.log(e);
                    }}
                  />
                )}

                <Fselect
                  title="Selecciona un monto (MXN)"
                  placeholder="Selecciona un monto (MXN)"
                  options={availableAmount}
                  value={availableAmount[0]}
                  onChange={(value) => {
                    formikDropdownScreen.setFieldValue("amount", value);
                  }}
                  errorMessage={formikDropdownScreen.errors.amount}
                />
                <Fbutton
                  value={"Recargar"}
                  disabled={!formikDropdownScreen.isValid}
                  onClick={formikDropdownScreen.handleSubmit}
                />

                {state.product?.product?.accountNumber ? (
                  <div className="text-Secondary text-center text-xl p-4 cursor-pointer">
                    <div
                      onClick={() => {
                        deleteFromFavorites();
                      }}
                    >
                      Eliminar de favoritos
                    </div>
                  </div>
                ) : null}
              </div>
            </form>
          </div>
        </>
      ) : null}
    </>
  );
};

export default AmountDropdownListScreen;
